<template>
<div>
  <b-navbar toggleable="lg" fixed="top">
    <b-navbar-brand class="header-name" :to="{name: 'homeLink'}">COVID-19 Cardiology Coalition</b-navbar-brand>
    <b-navbar-toggle class="custom-toggler" target="nav-collapse" v-click-outside="hide"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto" >
        <b-nav-form>
        </b-nav-form>
         <b-nav-item :to="{name: 'homeLink'}">Home</b-nav-item>
          <b-nav-item class="d-md-flex d-lg-none" :to="{name: 'guidesLink'}">Guide</b-nav-item>
          <b-nav-item :to="{name: 'advocacyLink'}">Advocacy</b-nav-item>
         <b-nav-item :to="{name: 'contactLink'}" >Contact</b-nav-item>
         <b-nav-item :to="{name: 'teamLink'}" >Team</b-nav-item>
         <b-nav-item v-show=true :to="{name: 'aboutLink'}" >Terms & Conditions</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div> 
</template>

<script src="https://cdn.jsdelivr.net/lodash/4.13.1/lodash.js"></script>

<script>
import {mapGetters} from 'vuex'  
import ClickOutside from 'vue-click-outside'
import * as $ from 'jquery';


export default {
    name: 'appHeader',
    data() {
        return{
            search_data:[],
            search:'',
        }

    },
    mounted () {
    // prevent click outside event with popupItem.
    this.popupItem = this.$el
  },
    methods:{

        hide(){
             if ($('.navbar-toggler').attr('aria-expanded') === "true") {
                    this.$root.$emit('bv::toggle::collapse', 'nav-collapse')

            }
        }
       
    },
    directives: {
         ClickOutside
     },
    
    computed: {
            ...mapGetters([
                'getGeneralContent',
                    'getInterventionalContent',
                    'getEpContent',
                    'getAdvImgContent',
                    'getAdvHfContent',
                    'getAlgorithmContent',
                    'getNonCardsContent',
                    'getOthersContent',
                    'getCccContent',
            ]),   
        },

}
</script>

   
<style>
    .navbar-toggler-icon {
        background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>") !important;
    }
</style>

<style scoped>
    .navbar {
     background: linear-gradient(#e11127,#c10e21)
    }
    .navbar-light .navbar-brand {
        font-weight: 600;
        color:white;
    }
    
    .navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
        color: white;
    }
    
    .navbar-light .navbar-nav .nav-link {
        color: white;
 
    }

    .navbar-light .navbar-nav .nav-link:hover{
        color: rgb(219, 214, 214);
    }
    .navbar-light .navbar-nav .nav-link:focus{
        color:rgb(219, 214, 214);
        font-weight: bold;
    }

    .navbar-light .navbar-toggler {
        color: white;
        border-color: white;
    }

   
    .navbar-toggler-icon {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 255)") !important;
    }

     .search-wrapper{
        display: none;
    }



</style>

